import { render, staticRenderFns } from "./OrderContent.vue?vue&type=template&id=f8930b0e&scoped=true"
import script from "./OrderContent.vue?vue&type=script&lang=js"
export * from "./OrderContent.vue?vue&type=script&lang=js"
import style0 from "./OrderContent.vue?vue&type=style&index=0&id=f8930b0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8930b0e",
  null
  
)

export default component.exports